<template>
  <div class="direct-document">
    <h1>
      <span>{{ $t('interface.registerCard') }}</span>
      <div class="sub">{{direct.type__name}} №{{direct.registration_number}} {{direct.registered_date | date}}</div>
    </h1>
    <table>
      <tr>
        <td width="50%">{{ $t('docflow.author') }}: <span class="bold">{{direct.author__initials}}</span></td>
        <td>{{ $t('docflow.fields.term_date') }}: <span class="bold">{{direct.term_date | date}}</span></td>
      </tr>
      <tr>
        <td><p v-if="direct.is_informational">{{ $t('docflow.is_informational') }}</p></td>
        <td>{{ $t('docflow.parentDocument') }}:
          <span class="bold" v-if="direct.parent">{{direct.parent.registration_number}} {{direct.parent.registered_date | date}}</span>
          <span class="bold" v-else>&ndash;</span>
        </td>
      </tr>
    </table>
    <div class="block">
      <span class="underline">{{ $t('interface.description') }}:</span> {{direct.description}}
    </div>
    <table>
      <tr>
        <td width="50%">
          <p>{{ $t('docflow.maintainer') }}:
            <span class="bold">{{direct.maintainer__initials}}</span></p>
          <p>{{ $t('admin.post_name') }}:
            <span class="bold">{{direct.maintainer__post_name}}</span></p>
        </td>
        <td>
          <p>{{ $t('docflow.approver') }}:
            <span class="bold">{{direct.approver__initials}}</span></p>
          <p>{{ $t('admin.post_name') }}:
            <span class="bold">{{direct.approver__post_name}}</span></p>
        </td>
      </tr>
      <tr>
        <td>
          <p class="mt-15">{{ $t('docflow.fields.supervisor') }}:
            <span class="bold">{{direct.supervisor__initials}}</span></p>
          <p>{{ $t('admin.post_name') }}:
            <span class="bold">{{direct.supervisor__post_name}}</span></p>
        </td>
      </tr>
    </table>
    {{$t('docflow.correspondents')}}:
    <ul class="mb-20">
      <li v-for="correspondent in direct.correspondents">{{correspondent.name}}</li>
    </ul>
    <span class="underline">{{$t('docflow.documentPlan')}}:</span>
    <table class="bordered">
      <tr>
        <td>№</td>
        <td>{{$t('docflow.plan.name')}}</td>
        <td>{{$t('docflow.plan.realisation_mechanisms')}}</td>
        <td>{{$t('docflow.plan.maintainer')}}</td>
        <td>{{$t('docflow.plan.executors')}}</td>
        <td>{{$t('docflow.plan.term')}}</td>
      </tr>
      <template v-for="plan_group in direct.plan_groups">
        <tr>
          <td>{{plan_group.order_number}}</td>
          <td colspan="5">{{plan_group.name}}</td>
        </tr>
        <tr v-for="plan_item in plan_group.items">
          <td>{{plan_group.order_number}}.{{plan_item.order_number}}</td>
          <td>{{plan_item.name}}</td>
          <td>{{plan_item.realisation_mechanisms}}</td>
          <td>{{plan_item.maintainer.name}}</td>
          <td>
            <p v-for="executor in plan_item.executors">{{executor.name}}</p>
          </td>
          <td>{{plan_item.term_date | date}}</td>
        </tr>
      </template>
      <tr v-for="plan_item in direct.plan_items">
        <td>{{plan_item.order_number}}</td>
        <td>{{plan_item.name}}</td>
        <td>{{plan_item.realisation_mechanisms}}</td>
        <td>{{plan_item.maintainer.name}}</td>
        <td>
          <p v-for="executor in plan_item.executors">{{executor.name}}</p>
        </td>
        <td>{{plan_item.term_date | date}}</td>
      </tr>
    </table>
    <span class="underline">{{$t('docflow.checkouts')}}:</span>
    <table class="bordered">
      <tr>
        <td width="10%">№</td>
        <td>{{$t('docflow.checkout.name')}}</td>
        <td width="30%">{{$t('docflow.checkout.states.checked_out')}}</td>
      </tr>
      <tr v-for="(checkout, n) in direct.checkouts">
        <td>{{n+1}}</td>
        <td>{{checkout.employee__initials}}</td>
        <td>
          <template v-if="checkout.state === 'checked_out'">{{$t('docflow.checkout.states.checked_out')}}</template>
          <template v-else>{{$t('docflow.checkout.states.not_checked')}}</template>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {priorityColors, stateColors} from '@/colorTypes'
  import Timeline from '@/components/Timeline'
  import Attachments from '@/components/Attachments'
  import Correspondents from '@/components/Correspondents'

  export default {
    components: {Timeline, Attachments, Correspondents},
    data() {
      return {
        stateColors
      }
    },
    computed: {
      ...mapState('Docflow', ['direct'])
    }
  }
</script>

<style lang="scss" scoped>
  .direct-document {
    font-size: 16px;
    line-height: 28px;

    h1 {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;

      .sub {
        font-size: 16px;
      }
    }
    ul {
      list-style: disc;
      li {
        margin-left: 18px;
      }
    }
    table {
      width: 100%;
      margin-bottom: 20px;

      &.bordered {
        margin-top: 10px;
        font-size: 14px;
        td {
          padding: 5px 10px;
          border: 1px solid #333;
        }
      }

      tr {
        td:first-child {
          padding-right: 20px;
        }
      }
    }
    .bold {
      font-weight: bold;
    }
    .underline {
      text-decoration: underline;
    }
  }
</style>
